import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-editor-icon',
  templateUrl: 'editor-icon.component.html'
})
export class EditorIconComponent {
  constructor() {}
}
